import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { duplicateQuoteRequestLine } from "#modules/quoteRequestLines/infra/duplicateQuoteRequestLine.api";
import { quoteRequestLinesQuery } from "#modules/quoteRequestLines/quoteRequestLinesQuery";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";

import { applyDuplicateQuoteRequestLineToCache } from "./applyDuplicateQuoteRequestLineToCache";

export const useDuplicateQuoteRequestLine = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { mutate, ...rest } = useMutation({
    mutationFn: duplicateQuoteRequestLine,
    onSuccess: (data, { useBatch, id }) => {
      if (data) {
        applyDuplicateQuoteRequestLineToCache({
          queryClient,
          duplicatedQuoteRequestLine: data,
          sourceId: id,
          useBatch,
        });
        void queryClient.invalidateQueries(quoteRequestQuery(data.quoteRequestId));
      }
      void queryClient.invalidateQueries(quoteRequestLinesQuery());
      showSuccessToast({ title: t("quoteRequestLine.actions.duplicate.success") });
    },
    onError: (e) => {
      showErrorToast({
        title: t("quoteRequestLine.actions.duplicate.error"),
      });
      if (e instanceof AxiosError) {
        logger.error(e.message);
      }
    },
  });

  return { duplicateQuoteRequestLine: mutate, ...rest };
};
